export const LOCAL_FILTER_FIELDS = [
    {
        label: "WO Number",
        type: "text",
        name: "workOrderNumber",
    },
    {
        label: "Branch",
        type: "text",
        name: "locationCode",
    }
]